import Table, { SORTER_STRING } from '../components/Table';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useContext, useEffect } from 'react';
import { fetch } from '../store/shownDataSlice';
import * as common from './common';



function formatWeekdays(row) {
    let days = [];
    if(row["arrangement_on_monday"]) days.push("E");
    if(row["arrangement_on_tuesday"]) days.push("T");
    if(row["arrangement_on_wednesday"]) days.push("K");
    if(row["arrangement_on_thursday"]) days.push("N");
    if(row["arrangement_on_friday"]) days.push("R");
    if(row["arrangement_on_saturday"]) days.push("L");
    if(row["arrangement_on_sunday"]) days.push("P");

    return days ? days.join(', ') : "-";
}

function ArrangementsTable({ data }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();


    
    return (
        <Table
            style={{ width: '100%' }}
            columnNames={[
                "Nimi",
                "Päevad",
                "Väljumine",
                "Juht",
                "Lõppeb",
                "Kirjeldus",
            ]}
            columnRenderers={[
                (row) => (<a onClick={() => navigate("/platform/arrangement/" + row["arrangement_id"])}>{row["arrangement_name"]}</a>),
                (row) => (<p>{formatWeekdays(row)}</p>),
                (row) => (<p>{row["arrangement_depart"]}</p>),
                (row) => (<p>{row["driver_firstname"]}</p>),
                (row) => (<p>{row["arrangement_end"]}</p>),
                (row) => (<p>{row["arrangement_description"]}</p>),
            ]}
            data={data}
        />
    );
}

export default ArrangementsTable;